/* eslint-disable */

<template>
    <v-card>
        <v-toolbar color="transparent" flat dense card>
          <h5 style="padding-right: 10px">{{subTitle}}</h5>
          <v-spacer></v-spacer>
        </v-toolbar>
      <v-divider></v-divider>

      <v-card-text class="pt-4">
        <div class="justify-center row layout ma-0">
          <v-progress-circular
            :size="150"
            :width="15"
            :rotate="-90"
            :value="caption2"
            :color="color"
          >
            {{ value }}
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>     
</template>

<script>
  /* eslint-disable */
export default {
    props: {
    icon: String,
    title:  [Number, String],
    subTitle: String,
    caption: String,
    value:  [Number, String],

    color: String
  },
    computed: {
        caption2 () {
            return this.value *1;
        }}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/widgets/statistic/CircleStatistic.vue